import { Grid, IconButton, Typography, useTheme } from "@mui/material";
import { CircleUserRound, User } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { DashboardHeaderActions } from "web_myplann/Dashboard/Components/DashboardHeaderActions";
import { DashboardHeroGradient } from "web_myplann/Dashboard/Components/DashboardHeroGradient";
import { useIsDashboardV2 } from "web_myplann/Dashboard/State/dashboardVariantContext";
import { Routing } from "web_myplann/Infrastructure/Routing/Routing";
import { device } from "web_myplann/Utils/device";

type DashboardGradientHeaderProps = {
	title: string;
	gradientTo: string;
	gradientFrom: string;
	gradientHeight: number;
	animateHeight?: boolean;
};

export const DashboardGradientHeader = ({
	title,
	gradientTo,
	gradientFrom,
	gradientHeight,
	animateHeight = true,
}: DashboardGradientHeaderProps) => {
	const { palette, iconSize } = useTheme();
	const navigate = useNavigate();
	const isDashboardV2 = useIsDashboardV2();
	const ProfileIcon = isDashboardV2 ? User : CircleUserRound;

	return (
		<>
			<DashboardHeroGradient
				gradientFrom={gradientFrom}
				gradientTo={gradientTo}
				height={gradientHeight}
				animateHeight={animateHeight}
			/>

			<Grid
				container
				direction="row"
				alignItems="center"
				px={1.6}
				mt={1}
				position="relative"
				zIndex={1}
			>
				<Grid size={{ xs: 4 }}>
					<IconButton
						onClick={() => {
							navigate(Routing.Profile.ProfileDetail.path());
							device.changeDashboardColor("");
						}}
					>
						<ProfileIcon
							size={iconSize.lg}
							color={palette.darkmodeText.white}
						/>
					</IconButton>
				</Grid>
				<Grid
					size={{ xs: 4 }}
					display="flex"
					justifyContent="center"
					textAlign="center"
				>
					{!isDashboardV2 && (
						<Typography
							fontWeight={700}
							fontSize={16}
							color={palette.darkmodeText.white}
						>
							{title}
						</Typography>
					)}
				</Grid>
				<Grid size={{ xs: 4 }} display="flex" justifyContent={"flex-end"}>
					<DashboardHeaderActions
						variant="gradient"
						chatBadgeColor={isDashboardV2 ? "chat" : "error"}
					/>
				</Grid>
			</Grid>
		</>
	);
};
